import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-org-chart-panel.css.lit';
import '../../outline-icon-baseline/outline-icon-baseline';
import '@phase2/outline-icon';

/**
 * The OutlineOrgChartPanelContent component
 * @element outline-org-chart-panel-content
 */
@customElement('outline-org-chart-panel-content')
export class OutlineOrgChartPanelContent extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  @property({ attribute: 'hide-icon' })
  hideIcon: boolean;

  @property({ attribute: 'header-text' })
  headerText: string;

  @property({ attribute: 'profile-link' })
  profileLink: string;

  @property({ attribute: 'sub-header-text' })
  subHeaderText: string;

  render(): TemplateResult {
    return html`
      <div class="org-chart-panel-content">
        ${!this.hideIcon
          ? html`<div class="panel-content-icon">
              <outline-icon
                library="bootstrap"
                name="arrow-up-short"
                size="20px"
              ></outline-icon>
            </div>`
          : null}
        <div class="org-chart-panel--header">
          <div class="header-text">
            <a class="header-link" href="${this.profileLink}">
              ${this.headerText}
            </a>
          </div>
          <div class="sub-header-text">${this.subHeaderText}</div>
        </div>
      </div>
    `;
  }
}
